// extracted by mini-css-extract-plugin
export default {"thead":"ArchivePosts_thead__LgylI","date":"ArchivePosts_date__3uJ6z","category":"ArchivePosts_category__Y-Cwv","title":"ArchivePosts_title__bAPZX"};